import {ActionTree} from 'vuex'
import axios, {AxiosResponse, AxiosError} from "axios";
import * as moment from 'moment';
import Segment from "../ts/SegmentInterface";
import {v4 as uuid} from 'uuid';

export const actions: ActionTree<any, any> = {

    runElasticSearchQuery: ({state, getters, commit, dispatch}, form) => {

        commit('setQueryRunning', true);

        return new Promise((resolve, reject) => {

            form.send('post', '/query/execute', form)

                .then((response: AxiosResponse) => {
                    resolve(response);

                    commit('setMatchCount', response.data.matches);
                    commit('setExecutionTime', response.data.execution_time);
                    commit('setResponseRate', response.data.response_rate);
                    commit('setQueryRunning', false);
                })
                .catch((error: AxiosError) => {
                    commit('setQueryRunning', false);
                    reject(error);
                });

        });
    },

    validateElasticSearchQuery: ({state, getters, commit, dispatch}, form) => {

        return new Promise((resolve, reject) => {

            form.send('post', '/query/validate', form)

                .then((response: AxiosResponse) => {
                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });

        });
    },

    saveSegment: ({state, getters, commit, rootState}, form) => {

        commit('setSegmentSaving', true);

        return new Promise((resolve, reject) => {

            form.send('post', '/segments', form)

                .then((response: AxiosResponse) => {
                    commit('newSegment', response.data.segment);
                    commit('setSegmentSaving', false);

                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    commit('setSegmentSaving', false);
                    reject(error);
                });
        });
    },

    updateSegment: ({state, getters, commit, rootState}, form) => {

        commit('setSegmentSaving', true);

        return new Promise((resolve, reject) => {

            form.send('put', '/segments', form)

                .then((response: AxiosResponse) => {
                    commit('updateSegment', response.data.segment);
                    commit('setSegmentSaving', false);

                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    commit('setSegmentSaving', false);
                    reject(error);
                });
        });
    },

    shareSegment: ({state, getters, commit, rootState}, segment: Segment) => {

        commit('updateSegment', segment);

        return new Promise((resolve, reject) => {

            axios.put('/segment/' + segment.id + '/share')

                .then((response: AxiosResponse) => {
                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    segment.shared = !segment.shared;
                    commit('updateSegment', segment);
                    reject(error);
                });
        });
    },

    cloneSegment({state, getters, commit, rootState}, segment: Segment) {

        const rollback = [...state.segments];

        // Clone
        let defTemp = Object.assign({}, segment);
        defTemp.id = uuid();
        defTemp.name = defTemp.name + ' (CLONED)';

        commit('newSegment', defTemp);

        let defNew = Object.assign({}, segment);
        defNew.id = null;
        defNew.name = defNew.name + ' (CLONED)';

        return new Promise((resolve, reject) => {

            axios.post('/segments', defNew)

                .then((response: AxiosResponse) => {
                    commit('setSegmentId', {tempId: defTemp.id, newId: response.data.segment.id});
                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    commit('setSegments', rollback);
                    reject(error);
                });
        });
    },

    deleteSegment: ({state, getters, commit, rootState}, id) => {

        const rollback = [...state.segments];

        commit('deleteSegment', id);

        return new Promise((resolve, reject) => {

            axios.delete('/segment/' + id)

                .then((response: AxiosResponse) => {
                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    commit('setSegments', rollback);
                    reject(error);
                });
        });
    },

    getSegments: ({state, getters, commit, rootState}, forceUpdate: boolean) => {

        if (forceUpdate) {
            state.segmentsCacheExpires = null;
        }

        if (state.segmentsCacheExpires === null || moment().isAfter(state.segmentsCacheExpires)) {

            commit('setSegmentsLoading', true);

            return new Promise((resolve, reject) => {

                axios.get('/segments')

                    .then((response: AxiosResponse) => {

                        commit('setSegments', response.data.segments);
                        commit('setSegmentsLoading', false);
                        resolve(null);
                    })
                    .catch((error: AxiosError) => {
                        commit('setSegmentsLoading', false);
                        reject(error);
                    });
            });
        }
    },
}